import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/logisticsAsset/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/cityEnergy/img/1.avif';
import image2 from '@src/assets/images/solution/cityEnergy/img/2.avif';
import image3 from '@src/assets/images/solution/cityEnergy/img/3.avif';
import image4 from '@src/assets/images/solution/cityEnergy/img/4.avif';
import image5 from '@src/assets/images/solution/cityEnergy/img/5.avif';
import image6 from '@src/assets/images/solution/cityEnergy/img/6.avif';

export default {
  type: 'エネルギー/環境ソリューション',

  banner: {
    title: '原子力発電所でも見逃さないフォークリフト位置追跡システム',
    desc: 'UWB位置ベース技術によりフォークリフトの移動を追跡し、廃棄物運搬経路を自動保存することで、監督機関への対応と資産セキュリティ強化を同時に実現します。',
  },

  video: {
    title: '強固な構造物、弱い信号。ORBROはその限界を超える。',
    desc: '鉄板で覆われた空間や10メートル以上の高い天井でも、ORBROの位置追跡技術は正確に信号を受信します。発電所内の資産がどこにあったのか、いつ移動したのか、誰が搬出したのかをすべてデータで証明できます。',
    play: video,
  },

  func: [
    {
      theme: '極限環境でも途切れない高精度位置追跡',
      title: '金属密閉構造でも安定した位置データ確保',
      desc: '金属構造物に囲まれた閉鎖空間でも、ORBROの位置追跡システムは信号損失なく安定した性能を維持します。従来のTDoA技術では追跡が不可能だった環境でも±30cm以内の高精度位置データを提供します。',
      sub1: '高精度を提供',
      icon1: IconRulerGray,
      sub2: '迅速なデータ連携',
      icon2: IconShareGray,
      image: image1,
    },
    {
      title: '高天井にも対応可能',
      desc: '10m以上の天井高を持つ空間でも正確な位置認識が可能です。最小限のインフラ設置で広いエリアをカバーし、設置効率と運用利便性を両立します。',
      sub1: 'リスク資産指定',
      icon1: IconWarningGray,
      sub2: '対応方法設定',
      icon2: IconBellGray,
      image: image2,
    },
    {
      title: '高速移動や複雑な動線でも途切れない受信',
      desc: 'フォークリフトが高速で移動したり狭いエリアを繰り返し運行しても、信号損失なくすべての動線が正確に記録されます。屋内反射環境でも途切れないデータを確保できます。',
      sub1: '高精度を提供',
      icon1: IconRulerGray,
      sub2: '迅速なデータ連携',
      icon2: IconChainLinkGray,
      image: image3,
    },
    {
      theme: '精密アルゴリズムと履歴ベースの運用最適化',
      title: 'Advanced TDoA高精度アルゴリズム適用',
      desc: '時間同期、クロック誤差補正、最小二乗法ベースの位置計算など6段階の精密処理を経て、複雑な環境でも正確な位置を算出します。ORBRO独自技術で産業現場に最適な精度と安定性を確保しました。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウド保存',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      title: 'Multipath/NLOS環境対応フィルタリング',
      desc: '信号反射や非視距離(NLOS)条件下での歪んだデータを自動で除去し、実際の経路に基づく精密な位置を提供します。Multipath環境でも98%以上の位置特定成功率を維持します。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウド保存',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      title: 'フォークリフト移動履歴タイムライン管理',
      desc: 'フォークリフトの移動経路と位置変化が時系列で保存され、特定区間の滞留時間や経路逸脱も分析可能です。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウド保存',
      icon2: IconCloudCheckGray,
      image: image6,
    },
  ],

  subfunc: {
    title: '多様な機能',
    desc: '医療廃棄物は最後まで気を抜いてはいけません。わずかな油断やミスでも大きな医療事故につながる可能性があります。そのため、非常に精密な管理と安全性の確保が必要です。<br/>ORBROは安全で効率的な医療施設構築のために多様な機能を提供します。',

    data: [
      {
        icon: IconZoneGray,
        title: '金属構造内追跡',
        desc: '高天井金属空間でも安定データ。',
      },
      {
        icon: IconRulerGray,
        title: 'ATDoA高精度対応',
        desc: '高速移動車両も±50cm追跡。',
      },
      {
        icon: IconChainLink,
        title: 'Multipath/NLOS内蔵',
        desc: '反射遮断環境でも誤差最小化。',
      },
      {
        icon: IconDashboard,
        title: 'リアルタイム位置可視化',
        desc: '車両位置を即座にダッシュボード表示。',
      },
      {
        icon: IconRoute,
        title: '移動履歴タイムライン',
        desc: '移動履歴を時系列で保存表示。',
      },
      {
        icon: IconBinocularsGray,
        title: '高速移動も連続追跡',
        desc: '高速車両も途切れず追跡。',
      },
      {
        icon: IconChartRadius,
        title: '監査用データ活用',
        desc: '履歴で監査や規制対応可能。',
      },
      {
        icon: IconWarning,
        title: '区域出入自動検知',
        desc: '重要区域出入を自動記録。',
      },
      {
        icon: IconBell,
        title: '異常停止通知',
        desc: '長時間停止時に自動通知。',
      },
      {
        icon: IconRoute,
        title: '衝突防止動線監視',
        desc: '経路分析で衝突を防止。',
      },
    ],
  },

  system: {
    title: 'システム構成',
    img: rtlsSystem,
  },

  productTitle: '製品構成',
  product: [{ tag: 'assetPackage' }, { tag: 'workerPackage' }],

  contents: [{ data: 'medicalPatient' }, { data: 'officeAsset' }, { data: 'blogMedical' }, { data: 'blogRTLS' }],
};
